import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function openTravelExpenses(affectedStaffId: number) {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.openTravelExpenses.url, { id: affectedStaffId }))
    .post()
}
